import React from 'react'

const SonPXW400Shouldercamcorder = () => {
  return (
    <div>SonPXW400Shouldercamcorder</div>
  )
}

export default SonPXW400Shouldercamcorder